function sortModesByDuration(data: any) {
  function convertToMinutes(timeString: string) {
    let totalMinutes = 0;

    const hourMatch = timeString.match(/(\d+)\s*hour(s)?/i);
    const minuteMatch = timeString.match(/(\d+)\s*min(s)?/i);

    if (hourMatch) {
      totalMinutes += parseInt(hourMatch[1], 10) * 60;
    }

    if (minuteMatch) {
      totalMinutes += parseInt(minuteMatch[1], 10);
    }

    return totalMinutes;
  }

  return Object.keys(data)
    .map((key) => ({
      id: key,
      minutes: convertToMinutes(data[key].duration),
    }))
    .sort((a, b) => a.minutes - b.minutes)
    .map((entry) => entry.id);
}
export default sortModesByDuration;
